/*!
Copyright (C) 2022 Liberty Infrasystems LLC. All rights reserved.
*/

class RetryExhaustedException {
    constructor({ maxAttempts }) {
        this.message = `retry exhausted max attempts ${maxAttempts}`;
        this.maxAttempts = maxAttempts;
    }
}

export { RetryExhaustedException };
